import Mustache from "mustache";
import { converter } from "$md-converter";
import { escapeHTML } from "$json/lib/escape";
/* info-per-question:
 *
 * Show information source when focusing the question to which it
 * belongs;
 *
 * Author: Niels Giesen
 * Copyright 2015 Berkeley Bridge
 *
 */
(function ($, doc) {
  $(function () {
    var infosources,
      tmpl = $("#bb-p-info-per-question-template").html(),
      elt = "bb-p-info-per-question";

    Mustache.tags = ["[[", "]]"];

    function prepareSource(source) {
      return $.extend({}, source, {
        description: source.description || source.content,
        content: source.isurl
          ? source.content
          : converter.makeHtml(escapeHTML(source.content))
      });
    }

    function ditch(id) {
      var elt = doc.getElementById(id);
      if (elt) elt.parentNode.removeChild(elt);
    }

    $(doc).on("focus", ".bb-questionlabelgroup :input", function (ev) {
      var $this = $(this);
      var id =
          this.type && this.type === "radio"
            ? $this.parents(".radiogroup").data("control") &&
              $this.parents(".radiogroup").data("control")._originalid
            : $this.data("control") && $this.data("control")._originalid,
        srcs = $.map(
          $.grep(infosources, function (src) {
            return src.belongsto === id;
          }),
          prepareSource
        );

      ditch(elt);
      if (srcs.length > 0) {
        var node = getQuestionLabelGroup(this);
        node.insertAdjacentHTML(
          "afterEnd",
          '<div id="' +
            elt +
            '">' +
            Mustache.render(tmpl, { sources: srcs }) +
            "</div>"
        );
      }
      return true;
    });

    function getQuestionLabelGroup(node) {
      var klass;
      while (
        ((node = node.parentNode),
        (klass = node.getAttribute("class")),
        !klass || klass.split(" ").indexOf("bb-questionlabelgroup") === -1)
      );
      return node;
    }

    $(doc).on("bb:preHandleData", function (event, data) {
      if (data && data.informationsources) {
        infosources = data.informationsources;
      }
    });
  });
})(jQuery, document);
